export const covidDefaultCoordinates = {
  mapCenter: [0.2284, 40.9098],
  zoomLevel: 1,
};
export const ebolaDefaultCoordinates = {
  mapCenter: [-11.779889, 8.460555],
  zoomLevel: 16,
};
